import { Lightning as lng, Utils } from '@lightningjs/sdk';
import { Theme } from '../../../config/theme';
import { ZappingBarCard } from '../ZappingBarCard';
import { MiniEpgChannelCard } from './MiniEpgChannelCard';

export const _constants = {
  channelCardHeight: 120,
  channelCardBottomMargin: 10,
  delay: 50,
  verticalPaddingFavorite: 35,
  verticalPadding: 20,
  leftPadding: 120,
  rightPadding: 20,
  maxTextWidth: 180,
  maxImageWidth: 180,
  selectorIconWidth: 30,
  selectorIconHeight: 60,
};

export class MiniEpgChannelSelector extends lng.Component {
  static _template() {
    return {
      w: w => w,
      h: h => h,
      clipping: true,
      ChannelCardsContainer: {
        h: h => h,
        w: w => w,
      },
      SelectorIcon: {
        y: h => h / 2,
        mountY: 0.5,
        w: _constants.selectorIconWidth,
        h: _constants.selectorIconHeight,
        src: Utils.asset('images/zappingBar/selector.png'),
        color: Theme.Colors.Primary,
      },
    };
  }

  _init() {
    this._cardsContainer = this.tag('ChannelCardsContainer');
    this.prevTime = 0;
    this._params = undefined;
  }

  _handleDown() {
    let now = new Date().getTime();
    if (now - this.prevTime > _constants.delay) {
      this.prevTime = now;
      this.shiftItemUp();
      this.updateUIAnimated();
      this.signal('loadNewChannel', this._cardsContainer.children[5].channelID);
    }
    return false;
  }

  _handleUp() {
    let now = new Date().getTime();
    if (now - this.prevTime > _constants.delay) {
      this.prevTime = now;
      this.shiftItemDown();
      this.updateUIAnimated();
      this.signal('loadNewChannel', this._cardsContainer.children[5].channelID);
    }
    return false;
  }

  _getFocused() {
    return this._cardsContainer.children[5];
  }

  shiftItemUp() {
    this._cardsContainer.children[5].focused = false;
    let card = this._cardsContainer.childList.first;
    this._cardsContainer.childList.remove(card);
    this._cardsContainer.childList.add(card);
    this._cardsContainer.children[5].focused = true;
  }

  shiftItemDown() {
    this._cardsContainer.children[5].focused = false;
    let card = this._cardsContainer.childList.last;
    this._cardsContainer.childList.remove(card);
    this._cardsContainer.childList.addAt(card, 0);
    this._cardsContainer.children[5].focused = true;
  }

  updateUI() {
    this._cardsContainer.childList.forEach((card, i) => {
      card.patch({ y: (_constants.channelCardHeight + _constants.channelCardBottomMargin) * (i - 4) });
    });
  }

  updateUIAnimated() {
    this._cardsContainer.childList.forEach((card, i) => {
      if (i === 0) {
        card.patch({ y: (_constants.channelCardHeight + _constants.channelCardBottomMargin) * (i - 4) });
      }
      if (i < 10) {
        card.setSmooth('y', (_constants.channelCardHeight + _constants.channelCardBottomMargin) * (i - 4));
      } else {
        card.patch({ y: (_constants.channelCardHeight + _constants.channelCardBottomMargin) * (i - 4) });
      }
    });
  }

  set backend(back) {
    this._backend = back;
  }

  /**
   * @param {ChannelModel[]} channelArray
   */
  set channels(channelArray) {
    // check if different from saved
    if (this._channelData === channelArray) {
      // data equal do nothing
      return;
    }
    // save data
    this._channelData = channelArray;
    // clear and build entire list of channels
    this._cardsContainer.childList.clear();
    channelArray.forEach((channel, i) => {
      this._cardsContainer.childList.a({
        type: MiniEpgChannelCard,
        y: (_constants.channelCardHeight + _constants.channelCardBottomMargin) * (i - 4),
        channelModel: channel,
        backend: this._backend,
      });
    });
    this.checkEnoughItems();
    this._cardsContainer.children[5].focused = true;
  }

  /**
   * @param {string} channelId
   */
  set currentChannel(channelId) {
    // set channel to current
    // // select current channel
    for (let i = 0; i < this._cardsContainer.childList.length; i++) {
      if (this._cardsContainer.children[5].channelID === channelId) {
        break;
      } else {
        this.shiftItemUp();
      }
    }
    this.updateUI();
  }

  checkEnoughItems() {
    // add the same items if there are less than 10
    while (this._cardsContainer.childList.length < 10) {
      this._cardsContainer.children.forEach(item => {
        this._cardsContainer.childList.a({
          type: ZappingBarCard,
          y: 0,
          channelModel: item.channelModel,
          backend: this._backend,
        });
      });
    }
  }
}
